import {canShareWithTeam} from '@netx/core-team-access/enablers';
import {type ISavedCart} from '../schema';

export const canShareSavedCartWithTeam = (
	savedCart?: Pick<ISavedCart, 'canManage'>,
) => canShareWithTeam() && savedCart?.canManage === true;

export default canShareSavedCartWithTeam;
